const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

interface PaginationState {
    pageSize: number;
    pageSizeOptions?: number[];
}

/**
 * Whether a list should render its pagination bar.
 *
 * A result set that fits on a single smallest-size page has nothing to paginate, so the bar
 * stays hidden (MP-14788). Once the user picks a bigger page size the bar has to stay on
 * screen even for a short result set: the page-size select lives inside it, so hiding it
 * locks the list on that size until a reload (MP-15882).
 */
export const shouldShowPagination = (
    totalCount: number,
    { pageSize, pageSizeOptions }: PaginationState,
): boolean => {
    if (totalCount <= 0) return false;

    const options = pageSizeOptions?.length ? pageSizeOptions : DEFAULT_PAGE_SIZE_OPTIONS;
    const smallestPageSize = Math.min(...options);

    if (pageSize !== smallestPageSize) return true;

    return totalCount > pageSize;
};
